// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3VFKk","form":"styles_form__1NE4d"};